export default __webpack_public_path__ + "static/media/brand-5.ed33c6e8.png";